import React from "react";
import Link from "next/link";
import Image from "next/image";

const footerLinks = [
  { label: "Our Story",        href: "/homepage#story"    },
  { label: "Benefits",         href: "/homepage#benefits" },
  { label: "Privacy Policy",   href: "/privacy-policy"    },
  { label: "Terms of Service", href: "/terms-of-service"  },
  { label: "Refund Policy",    href: "/refund-policy"     },
  { label: "Shipping Policy",  href: "/shipping-policy"   },
];

export default function Footer() {
  return (
    <footer className="border-t border-pmu-taupe-light/20 py-12 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Brand */}
          <div className="flex items-center gap-2.5">
            <Image
              src="/assets/images/Pick_Me_Up-branding_logomark-blue-09-1773749520847.png"
              alt="Pick Me Up logo"
              width={100}
              height={40}
              className="object-contain h-10 w-auto"
            />
          </div>

          {/* Links */}
          <nav className="flex flex-wrap justify-center gap-8">
            {footerLinks?.map((link) => (
              <Link
                key={link?.label}
                href={link?.href}
                className="text-xs font-600 text-pmu-taupe hover:text-pmu-espresso transition-colors uppercase tracking-widest"
                style={{ fontWeight: 600, letterSpacing: "0.07em" }}
              >
                {link?.label}
              </Link>
            ))}
          </nav>

          {/* Social */}
          <div className="flex items-center gap-3">
            {[
              { label: "Instagram", icon: (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
                </svg>
              )},
              { label: "TikTok", icon: (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.76a4.85 4.85 0 01-1.01-.07z"/>
                </svg>
              )},
            ]?.map(({ label, icon }) => (
              <a
                key={label}
                href="#"
                aria-label={label}
                className="w-9 h-9 rounded-md border border-pmu-taupe-light/30 flex items-center justify-center text-pmu-taupe hover:text-pmu-espresso hover:border-pmu-espresso transition-all duration-200"
              >
                {icon}
              </a>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-6 border-t border-pmu-taupe-light/15 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-pmu-taupe-light uppercase tracking-widest" style={{ fontWeight: 500, letterSpacing: "0.06em" }}>
            © 2026 Pick Me Up Foods Inc.
          </p>
          <p className="text-xs text-pmu-taupe-light uppercase tracking-widest" style={{ fontWeight: 500, letterSpacing: "0.06em" }}>
            Vegan · Gluten-Free · Plant-Based
          </p>
        </div>
      </div>
    </footer>
  );
}